<div  class="mat-dialog-title">
  <h2>
    <mat-icon *ngIf="title_text && title_text.length>0">priority_high</mat-icon>
    {{title_text}}
  </h2>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  {{child_text}}<br>
  <!-- {{subject_text}} -->
</mat-dialog-content>
<mat-dialog-actions class="modal_buttons">
  <button mcButton variant="closedialog" mat-dialog-close>No</button>
  <button mcButton variant="confirmdialog" (click)="onConfirm()">Sì</button>
</mat-dialog-actions>
